export type DynamicMessage = string;

export const getWelcomeDirectAppointmentActivateErrorMessage = (
  carrierName: string,
): DynamicMessage =>
  `There was a problem while updating your direct appointments. Please check that your ${carrierName} credentials are correct and try again.`;

export const getAppointmentQueryParamErrorMessage = (
  humanReadableAppointmentType: string,
): DynamicMessage =>
  `The requested carrier enrollment was not found or is not available for ${humanReadableAppointmentType}s`;
